import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { Box, Button } from "@mui/material";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";

function getVesselOperatorPreferences(preferences, operatorOptions) {
  if (!preferences || preferences.length === 0) {
    console.warn("No vessel operator preferences provided");
    return [];
  }

  if (!operatorOptions || operatorOptions.length === 0) {
    console.warn("No vessel operator to select");
    return [];
  }

  let vesselOperatorPreferences = operatorOptions.filter(({ OPERATOR_KEY }) => {
    return preferences.find((preference) => {
      return Number(preference) === Number(OPERATOR_KEY);
    });
  });
  return vesselOperatorPreferences;
}

export default function VesselOperators(props) {
  const preferences = Array.isArray(props.preferences)
    ? props.preferences
    : [props.preferences];
  const selectedValue = {
    OPERATOR_KEY: props.operator_permit_number,
    NAME_FIRST: props.operator_first_name,
    NAME_MIDDLE: props.operator_middle_name,
    NAME_LAST: props.operator_last_name,
    NAME_EXT: props.operator_ext_name,
  };

  const vesselOperatorPreferences = getVesselOperatorPreferences(
    preferences,
    props.operatorOptions
  );

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    ignoreCase: true,
    trim: true,
    stringify: (option) =>
      option.OPERATOR_KEY +
      " " +
      option.NAME_FIRST +
      (option.NAME_MIDDLE ? " " + option.NAME_MIDDLE : "") +
      " " +
      option.NAME_LAST +
      (option.NAME_EXT ? " " + option.NAME_EXT : ""),
  });

  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Vessel Operator</h2>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12} md="auto">
          <Box display="flex" flexWrap="wrap" justifyContent="center">
            {vesselOperatorPreferences.map((trip, idx) => (
              <Box key={idx} m={0.5}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="form-input"
                  data-operator-key={trip.OPERATOR_KEY}
                  data-name-first={trip.NAME_FIRST}
                  data-name-middle={trip.NAME_MIDDLE}
                  data-name-last={trip.NAME_LAST}
                  data-name-ext={trip.NAME_EXT}
                  data-field={"vessel_operator"}
                  size="large"
                  onClick={(e) =>
                    props.handleTripOperatorPreferenceChange(e, trip)
                  }
                  key={trip.OPERATOR_KEY}
                >
                  {trip.OPERATOR_KEY +
                    " " +
                    trip.NAME_FIRST +
                    (trip.NAME_MIDDLE ? " " + trip.NAME_MIDDLE : "") +
                    " " +
                    trip.NAME_LAST +
                    (trip.NAME_EXT ? " " + trip.NAME_EXT : "")}
                </Button>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} md="auto">
          <Autocomplete
            id="vessel_operator_auto_complete"
            options={props.operatorOptions}
            getOptionLabel={(option) =>
              option.OPERATOR_KEY +
              " " +
              option.NAME_FIRST +
              (option.NAME_MIDDLE ? " " + option.NAME_MIDDLE : "") +
              " " +
              option.NAME_LAST +
              (option.NAME_EXT ? " " + option.NAME_EXT : "")
            }
            style={{ maxWidth: 350, minWidth: 250 }}
            onChange={props.changeHandler}
            defaultValue={
              props.operatorOptions.length === 1
                ? props.operatorOptions[0]
                : null
            }
            value={selectedValue}
            disabled={props.operatorOptions.length === 1}
            isOptionEqualToValue={(option) =>
              option.OPERATOR_KEY +
              " " +
              option.NAME_FIRST +
              " " +
              option.NAME_MIDDLE +
              " " +
              option.NAME_LAST +
              " " +
              option.NAME_EXT
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                InputLabelProps={{ style: { fontSize: 18 } }}
                label="Vessel Operator"
                helperText="Name or Permit Number"
              />
            )}
            filterOptions={filterOptions}
          />
        </Grid>
        <Grid item>
          <HelpText helpText={getHelpText(props.helpText, "operator")} />
        </Grid>
      </Grid>
    </Box>
  );
}
